import React from "react";
import { Link } from "react-router-dom";

export default function PopUp() {
    return (
            <Link to="/contact" className="pop">
                <h1>Need Help? Contact us</h1>
            </Link>
    )
}